module.exports = __webpack_public_path__ + "media/images/no_plan-9d944a8501fc8807874d5a678d207436.svg";